import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import QuickActions from "@/components/QuickActions";
import { ConfirmProvider } from "@/components/ConfirmProvider";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Pipeline from "@/pages/Pipeline";
import Clients from "@/pages/Clients";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Billing from "@/pages/Billing";
import Hosting from "@/pages/Hosting";
import Maintenance from "@/pages/Maintenance";
import Finance from "@/pages/Finance";
import Analytics from "@/pages/Analytics";
import Renewals from "@/pages/Renewals";
import Profitability from "@/pages/Profitability";
import Settings from "@/pages/Settings";
import "@/App.css";

const Page = ({ children }) => (
  <ProtectedRoute>
    <Layout>
      {children}
      <GlobalQuickActions />
    </Layout>
  </ProtectedRoute>
);

function GlobalQuickActions() {
  const { user } = useAuth();
  if (!user) return null;
  return <QuickActions />;
}

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Page><Dashboard /></Page>} />
            <Route path="/pipeline" element={<Page><Pipeline /></Page>} />
            <Route path="/projects" element={<Page><Projects /></Page>} />
            <Route path="/projects/:id" element={<Page><ProjectDetail /></Page>} />
            <Route path="/clients" element={<Page><Clients /></Page>} />
            <Route path="/billing" element={<Page><Billing /></Page>} />
            <Route path="/invoices" element={<Page><Billing /></Page>} />
            <Route path="/renewals" element={<Page><Renewals /></Page>} />
            <Route path="/profitability" element={<Page><Profitability /></Page>} />
            <Route path="/hosting" element={<Page><Hosting /></Page>} />
            <Route path="/maintenance" element={<Page><Maintenance /></Page>} />
            <Route path="/finance" element={<Page><Finance /></Page>} />
            <Route path="/analytics" element={<Page><Analytics /></Page>} />
            <Route path="/settings" element={<Page><Settings /></Page>} />
          </Routes>
        </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
